import { useEffect, useState } from "react";
import { supabase } from "./services/adminApi";
import { Navigate } from "react-router-dom";

export default function AdminRoute({ children }) {
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const checkAdmin = async () => {
      try {
        const {
          data: { user },
        } = await supabase.auth.getUser();

        if (!user) {
          if (!cancelled) setAllowed(false);
          return;
        }

        const { data } = await supabase
          .from("users")
          .select("role")
          .eq("id", user.id)
          .single();

        if (!cancelled) setAllowed(data?.role === "admin");
      } catch (err) {
        // Network/config failure must not leave the page hanging forever.
        console.error("Admin auth check failed:", err);
        if (!cancelled) setAllowed(false);
      }
    };

    checkAdmin();
    return () => {
      cancelled = true;
    };
  }, []);

  if (allowed === null) {
    return <div className="admin-boot">Checking access…</div>;
  }
  if (!allowed) return <Navigate to="/admin/login" replace />;

  return children;
}
